import { create } from 'zustand';
import { Session, Message, Scenario } from '../types';

interface SessionState {
  sessions: Session[];
  messages: Message[];
  scenario: Scenario | null;
  isLoadingSessions: boolean;
  isLoadingMessages: boolean;
  error: string | null;
  menuOpenId: string | null;
  editingSessionId: string | null;
  editingName: string;
  exportAsZip: boolean;

  setSessions: (sessions: Session[]) => void;
  setMessages: (messages: Message[]) => void;
  addMessage: (message: Message) => void;
  setScenario: (scenario: Scenario | null) => void;
  setIsLoadingSessions: (loading: boolean) => void;
  setIsLoadingMessages: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setMenuOpenId: (id: string | null) => void;
  setEditingSessionId: (id: string | null) => void;
  setEditingName: (name: string) => void;
  updateSessionInList: (sessionId: string, updates: Partial<Session>) => void;
  setExportAsZip: (exportAsZip: boolean) => void;
  removeSession: (sessionId: string) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  sessions: [],
  messages: [],
  scenario: null,
  isLoadingSessions: false,
  isLoadingMessages: false,
  error: null,
  menuOpenId: null,
  editingSessionId: null,
  editingName: "",
  exportAsZip: false,

  setSessions: (sessions) => set({ sessions }),
  setMessages: (messages) => set({ messages }),
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),
  setScenario: (scenario) => set({ scenario }),
  setIsLoadingSessions: (loading) => set({ isLoadingSessions: loading }),
  setIsLoadingMessages: (loading) => set({ isLoadingMessages: loading }),
  setError: (error) => set({ error }),
  setMenuOpenId: (id) => set({ menuOpenId: id }),
  setEditingSessionId: (id) => set({ editingSessionId: id }),
  setEditingName: (name) => set({ editingName: name }),
  updateSessionInList: (sessionId, updates) =>
    set((state) => ({
      sessions: state.sessions.map((s) =>
        s.id === sessionId ? { ...s, ...updates } : s,
      ),
    })),
  setExportAsZip: (exportAsZip) => set({ exportAsZip }),
  removeSession: (sessionId) =>
    set((state) => ({
      sessions: state.sessions.filter((s) => s.id !== sessionId),
    })),
}));
